import { format } from 'date-fns';

export const currentDate = format(new Date(), 'yyyy-MM-dd');

export function formatAnalyticAndReportsDate(date: string) {
  return date.split('-').reverse().join('.');
}
